import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import env from '~/libs/env'
import { phone as formatPhone } from '~/libs/format'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'

export function useSupportContact() {
  const { contactInfoPhone, contactInfoEmail, isEmbeddedLayout } = storeToRefs(useAffiliateCustomizationStore())

  const phone = computed(() => {
    const phoneNumber = isEmbeddedLayout.value ? (contactInfoPhone.value || env('embeddedSupportPhone')) : '855-853-6346'

    return formatPhone(phoneNumber)
  })

  const email = computed(() => {
    return isEmbeddedLayout.value ? (contactInfoEmail.value || env('embeddedSupportEmail')) : env('customerSupportEmail')
  })

  return { phone, email }
}
